/*
 * Public API Surface of api-client
 */

// ============================================================================
// V1 API (Legacy) - Import from 'api-client'
// ============================================================================
// OpenAPI v1 generated exports
export * from './lib/generated/api/api';
export * from './lib/generated/model/models';

// V1 Configuration exports
export * from './lib/generated/configuration';
export * from './lib/generated/variables';

// ============================================================================
// V2 API (Enhanced) - Import from 'api-client' with V2 suffix
// ============================================================================
// V2 services and models - use AuthServiceV2, HealthServiceV2, etc.
export * from './lib/v2-exports';
